// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarProf_container__YoR9h {
  padding: 0;
  /* margin-top : 4em; */
  position: relative;
}
.sidebarProf_main__0IxxY {
  width: 20em;
  position: fixed;
  background-color: #2d3436;
  top: 3em;
  bottom: 0;
}

.sidebarProf_header__88gdU {
  display: flex;
  padding: 0.5em;
  justify-content: center;
}

.sidebarProf_imgContainer__oKjaX {
  display: flex;
  padding: 1.5em;
}
.sidebarProf_imgContainer__oKjaX img {
  border-radius: 50%;
  border: 3px solid white;
  /* margin : auto; */
}

.sidebarProf_home__2j2xd {
  text-align: end;
  color: white;
  padding-top: 0.5em;
  font-size: 25px;
}

.sidebarProf_hide__\\+S-B3 {
  margin-left: -16em;
  opacity: 0;
  transition-duration: 400ms;
}

.sidebarProf_show__jYStZ {
  margin-left: 0;
  opacity: 1;
  transition-duration: 400ms;
}
.sidebarProf_expand__ShCEo {
  right: 0em;
  transform: rotate(-180deg);
  transition-duration: 400ms;
}
.sidebarProf_collapse__8D1Z9 {
  right: -3em;
  transform: rotate(0deg);
  transition-duration: 400ms;
}
.sidebarProf_mainExpand__LIoVL {
  margin-left: 0;
  transition-duration: 200ms;
}
.sidebarProf_mainCollapse__pX1-K {
  margin-left: -16em;
  transition-duration: 200ms;
}

.sidebarProf_infoDiv__a7VRs {
  display: flex;
  flex-direction: column;
  padding: 0.5em 0.2em 0.5em 1em;
  text-align: start;
  color: white;
  font-size: 20px;
  overflow-x: visible;
  word-break: break-all;
}

.sidebarProf_infoDiv__a7VRs input {
  border-radius: 25px;
  color: black;
  padding-left: 0.5em;
}

.sidebarProf_buttonDiv__320gY {
  display: flex;
  justify-content: center;
}

.sidebarProf_buttonDiv__320gY button {
  padding: 0.5em;
  margin: 0.5em;
  color: white;
  border-radius: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebarProf.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".container {\n  padding: 0;\n  /* margin-top : 4em; */\n  position: relative;\n}\n.main {\n  width: 20em;\n  position: fixed;\n  background-color: #2d3436;\n  top: 3em;\n  bottom: 0;\n}\n\n.header {\n  display: flex;\n  padding: 0.5em;\n  justify-content: center;\n}\n\n.imgContainer {\n  display: flex;\n  padding: 1.5em;\n}\n.imgContainer img {\n  border-radius: 50%;\n  border: 3px solid white;\n  /* margin : auto; */\n}\n\n.home {\n  text-align: end;\n  color: white;\n  padding-top: 0.5em;\n  font-size: 25px;\n}\n\n.hide {\n  margin-left: -16em;\n  opacity: 0;\n  transition-duration: 400ms;\n}\n\n.show {\n  margin-left: 0;\n  opacity: 1;\n  transition-duration: 400ms;\n}\n.expand {\n  right: 0em;\n  transform: rotate(-180deg);\n  transition-duration: 400ms;\n}\n.collapse {\n  right: -3em;\n  transform: rotate(0deg);\n  transition-duration: 400ms;\n}\n.mainExpand {\n  margin-left: 0;\n  transition-duration: 200ms;\n}\n.mainCollapse {\n  margin-left: -16em;\n  transition-duration: 200ms;\n}\n\n.infoDiv {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5em 0.2em 0.5em 1em;\n  text-align: start;\n  color: white;\n  font-size: 20px;\n  overflow-x: visible;\n  word-break: break-all;\n}\n\n.infoDiv input {\n  border-radius: 25px;\n  color: black;\n  padding-left: 0.5em;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: center;\n}\n\n.buttonDiv button {\n  padding: 0.5em;\n  margin: 0.5em;\n  color: white;\n  border-radius: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sidebarProf_container__YoR9h`,
	"main": `sidebarProf_main__0IxxY`,
	"header": `sidebarProf_header__88gdU`,
	"imgContainer": `sidebarProf_imgContainer__oKjaX`,
	"home": `sidebarProf_home__2j2xd`,
	"hide": `sidebarProf_hide__+S-B3`,
	"show": `sidebarProf_show__jYStZ`,
	"expand": `sidebarProf_expand__ShCEo`,
	"collapse": `sidebarProf_collapse__8D1Z9`,
	"mainExpand": `sidebarProf_mainExpand__LIoVL`,
	"mainCollapse": `sidebarProf_mainCollapse__pX1-K`,
	"infoDiv": `sidebarProf_infoDiv__a7VRs`,
	"buttonDiv": `sidebarProf_buttonDiv__320gY`
};
export default ___CSS_LOADER_EXPORT___;
